import { gql } from '@apollo/client';

export const listUsersQuery = gql`
  query ListUsers($input: ListUsersInput!) {
    listUsers(input: $input) {
      users {
        id
        username
        email
        avatar
        groupName
        joinDate
        status
        phoneNumber
        point
        __typename
      }
      total
    }
  }
`;
